import * as React from "react";
import { AddressDetailModel } from "../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { AddressTypeMap } from "../../ClientRecord/Resource/Contents";
import { prepareTypography } from "../../Common/Review/ReviewParser";
import { fieldDefaultValue } from "../Resource/CustomerMergeHelper";

interface IAddressesProps {
    aData: Array<AddressDetailModel>;
    otheraData: Array<AddressDetailModel>;
}

export const Addresses = (props: IAddressesProps) => {
    // extract the union set of address type
    const addressTypeFromaData = props?.aData?.map((e) => e?.PhysicalAddressType);
    const addressTypeFromOtheraData = props?.otheraData?.map((e) => e?.PhysicalAddressType);

    // declare a new set
    const addressTypeSet = new Set();
    addressTypeFromaData?.forEach((e) => addressTypeSet.add(e));
    addressTypeFromOtheraData?.forEach((e) => addressTypeSet.add(e));

    // Composite Address aray based on the set
    const _sortedAddress = [];
    for (const ele of addressTypeSet) {
        // find if type already existed
        const _data = props?.aData?.find((e) => e?.PhysicalAddressType == ele);
        if (_data) {
            _sortedAddress.push(_data);
        } else {
            // need create empty object
            _sortedAddress.push({ PhysicalAddressType: null, Address: null });
        }
    }

    const addressConfig = (aData: Array<AddressDetailModel>) => {
        const result = [];
        aData.forEach((e) => {
            result.push(
                {
                    title: "Address type",
                    data: fieldDefaultValue(AddressTypeMap[e?.PhysicalAddressType]),
                },
                {
                    title: "Line 1",
                    data: fieldDefaultValue(e?.Address?.Address1),
                },
                {
                    title: "Line 2",
                    data: fieldDefaultValue(e?.Address?.Address2),
                },
                {
                    title: "Line 3",
                    data: fieldDefaultValue(e?.Address?.Address3),
                },
                {
                    title: "Line 4",
                    data: fieldDefaultValue(e?.Address?.Address4),
                },
                {
                    title: "Postcode",
                    data: fieldDefaultValue(e?.Address?.PostCode),
                }
            );
        });
        return result;
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>Addresses</u>
                    </h3>
                </div>
            </div>
            <Typography {...prepareTypography(addressConfig(_sortedAddress), 1, "common")} />
        </>
    );
};
